// extracted by mini-css-extract-plugin
export default {"link":"tU6U8R3g"};